<template>
    <div>
        <el-tabs
            v-model="currentCityId"
        >
            <el-tab-pane
                v-for="item in cityList"
                :key="item.value"
                :label="item.label"
                :name="String(item.value)"
            />
        </el-tabs>
        <city-edit
            v-for="(cityInfo, cityId) in allCityStateInfo"
            v-show="cityId == currentCityId"
            :ref="`city-${cityId}`"
            :key="cityId"
            :mode="mode"
            :current-city-info="cityInfo"
            :current-city-id="+cityId"
            :create-info-model="createInfoModel"
            :base-info-model="baseInfoModel"
            :is-supplies="isSupplies"
            :is-discount-sku="isDiscountSku"
            :focus-attr-data="focusAttrData"
        />
    </div>
</template>

<script>
import emitter from 'utils/emitter';
import { getCategoryInfoById } from 'utils/category';
import CityEdit from './edit';
import { createNewToken, citySalesInfoToken, shared } from '../shareState';
import { getBaseModel } from '../baseModel';

const baseModel = getBaseModel();
const initState = () => ({
    manufacturerId: '', // 生产商
    manufacturerName: '', // 生产商名
    purchasePrice: undefined, // 城市采购价
    shippingType: '', // 配送方式
    rdcId: '', // 仓
    sellPrice: undefined, // 城市售价
});

export default {
    name: citySalesInfoToken,
    components: {
        CityEdit,
    },
    mixins: [emitter],
    data() {
        return {
            cityList: [],
            currentCityId: '',
            allCityStateInfo: {}, // 城市数据模型
            // showUnitList: [], // 购买步长单位列表
            // originUnitList: [], // 单位列表
            createInfoModel: {}, // 提报信息数据
            baseInfoModel: {}, // 基础信息数据
            mode: 'edit',
            haveInit: false, // 暂时没有用到
            existedCityIds: shared.existedCityIds,
            focusAttrData: {}, // c端展示重点属性
        };
    },
    computed: {
        currentStateInfo() {
            return this.allCityStateInfo[+this.currentCityId];
        },
        // 分类品类是物资品
        isSupplies() {
            const target = getCategoryInfoById(this.categoryId, shared.categoryTreeData);
            return target && target.categoryType === 2;
        },
        categoryId() {
            return this.createInfoModel.categoryId;
        },
        // 是否是b货  货品类型 = 特惠 为b品
        isDiscountSku() {
            // attrId === 20019 为货品类型
            const productType = this.createInfoModel.keyAttributes.find((item) => item.attrId === 20019);
            // id === 56365 为特惠
            return productType && productType.selectedValues[0].id === 56365;
        },
    },
    created() {
        baseModel.registerVM(this, citySalesInfoToken);
    },
    async activated() {
        if (shared.stepChangeType === 'next') {
            try {
                await this.init();
            } catch (error) {
                console.warn(error);
            } finally {
                this.dispatch(createNewToken, 'page-loaded', true);
            }
        }
    },
    methods: {
        async init() {
            const draft = await this.fetchNewCreateData(baseModel.models.applyId);
            baseModel.setData(draft);
            const citySalesInfo = baseModel.initCitySalesInfo;
            this.createInfoModel = baseModel.initCreateInfo.form;
            this.baseInfoModel = baseModel.initProductBaseInfo;
            this.cityList = [];
            shared.allCityList.forEach((city) => {
                if (this.createInfoModel.cityIds.includes(city.managementCityId)) {
                    this.cityList.push({
                        value: city.managementCityId,
                        label: city.managementCityName,
                    });
                }
            });
            this.allCityStateInfo = this.formatCityStateInfoWithDetail(this.cityList, citySalesInfo);

            // 初始化 currentCityId<el-tab> name属性默认String类型
            this.currentCityId = String(this.cityList[0].value);
            this.$nextTick(() => {
                this.cityList.forEach((city) => {
                    const cityVm = this.$refs[`city-${city.value}`][0];
                    cityVm.init();
                });
            });
            this.queryFocusAttr();
        },

        // 获取重点属性
        async queryFocusAttr() {
            if (!this.createInfoModel.bgCategoryId) return;
            const res = await this.$hPost('/api/vss/shepherd/ProductAttrDescQueryTService/queryAttrDescByBgCategoryId', { bgCategoryId: this.form.bgCategoryId }).catch(() => ({}));

            this.focusAttrData = {
                extAttrList: (res.extAttrDesc || []).filter((item) => item.appDisplay).map((item) => item.attrId),
            };
            (res.fixedAttrDesc || []).forEach((item) => {
                this.focusAttrData[item.code] = item.appDisplay;
            });
        },

        formatCityStateInfoWithDetail(cityList, citySalesInfo) {
            const newStateInfo = (citySalesInfo || []).reduce((result, item) => {
                result[item.cityId] = {
                    cityId: item.cityId,
                    manufacturerId: item.manufacturerId || '',
                    manufacturerName: item.manufacturerName || '',
                    shippingType: item.shippingType || '',
                    rdcId: item.rdcId || '',
                    purchasePrice: item.purchasePrice || undefined, // 城市采购价
                    sellPrice: item.sellPrice || undefined, // 售价
                    citySkuAttributes: item.citySkuAttributes,
                };
                return result;
            }, {});
            const allCityStateInfo = cityList.reduce((result, item) => {
                result[item.value] = newStateInfo[item.value] ? {
                    cityId: item.value,
                    ...newStateInfo[item.value],
                } : {
                    cityId: item.value,
                    ...initState(),
                };
                return result;
            }, {});
            return allCityStateInfo;
        },
        async fetchNewCreateData(applyId) {
            const draftData = await this.$service.fetchNewSellDetail({ applyId });
            return draftData;
        },
        getVMPostData() {
            return this.allCityStateInfo;
        },
        async validate() {
            let validResult = true;
            // 校验所有城市
            const errors = [];
            for (let i = 0; i < this.cityList.length; i++) {
                const item = this.cityList[i];
                const valid = await this.$refs[`city-${item.value}`][0].validate();
                if (!valid) errors.push(item.label);
            }
            if (errors.length) {
                this.$message.error(`【${errors.join(',')}】填写信息有误`);
                validResult = false;
            }
            return validResult;
        },
    },
};
</script>
